export default __webpack_public_path__ + "static/media/article.fe21808c.png";